import React from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import CircularProgress from '@material-ui/core/CircularProgress'
import './styles.css'

export default (props) => {

    const handleConfirm = () => {
        props.setShowProgress(true)
        if(props.title === 'Bloquear'){
            props.block();
        }else if(props.title === 'Alertar'){
            props.alert();
        }else if(props.title === 'Excluir') {
            props.delete();
        }else if(props.title === 'Desbloquear'){
            props.unblock();
        }else if (props.title === 'Aprovar Cadastro' || 'Aprovar'){
            props.approval();
        }else{
            console.log('falha');
        }
    }

    const handleDecline = () => {
        props.decline(false);
    }

    return(
        <div>
            <Dialog
                open={props.showModal} 
                aria-labelledby="draggable-dialog-title" 
                maxWidth='sm'
            >
                <DialogContent>
                    <h2 className='modal-pj-title'>{props.title}</h2> <br/><br/>

                    <div className='modal-confirm-textt'>
                        <p className='ctsss'>{props.text}</p>
                    </div>
                    <br/><br/>
                    <div className='modal-confirm-buttonss'>
                        <button className='modal-confirm-buttons1' onClick={handleDecline} disabled={props.showProgress}>
                            Não, cancelar
                        </button>
                        <button className='modal-confirm-buttons1 btn-cnf' onClick={handleConfirm} disabled={props.showProgress}>
                            
                            {props.showProgress?
                                <CircularProgress color='primary' size={15} />:
                                <p className='modal-header-button-text'>Sim, confirmar</p>
                            }
                        </button>
                    </div>
                    <br/>
                </DialogContent>
            </Dialog>
        </div>
    )
}